









  import { Component, Vue } from 'vue-property-decorator';
  import { mapState } from "vuex";
  import { store, StoreState } from "src/store";
  import Sidebar from "./components/Sidebar.vue";
  import Header from "./components/Header.vue"
@Component({
  components: {
    Sidebar,Header
  },
  computed: {
    ...mapState({
        'logout': (state: StoreState) =>  state.account.logout_status

    })
  }
 
})
  export default class ChildRout extends Vue {




  }
